import React, { Component } from "react";
// import IdentityService from "../../common/identityService";
import Api from "../../common/api";
import ApiV2 from "../../common/apiV2";
import { Card, Form, Button, Row, Col, Container, Nav, Navbar} from "react-bootstrap";
import PropTypes from "prop-types";
import "./createSharelist.scss";
import { Redirect, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

class CreateSharelistPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxChecked: true,  
      name: null,
      caption: "",
      isPublic: false,
      registerClicked: false,
      successfulAdd: false
    };
  }

  redirectToProfile() {
    return (
      <Redirect to="/profile" />
    )
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.registerClicked === false &&
      this.state.registerClicked === true
    ) {
      try {
        const response = await ApiV2.createSharelist(
          this.state.name,
          this.state.isPublic,
          this.state.caption,
        );
        this.setState({
          successfulAdd: true
        });
        //Notification banner
        this.props.notifyInfo(
          "Successfully created " + this.state.name
        );
      } catch (e) {
          console.log("Error: ", JSON.stringify(e));
          this.props.notifyFailure(
            "Failed to create sharelist. Missing info"
          );
      }
      this.setState({
        registerClicked: false
      });
    }
  }

  onRegisterClicked = () => {
    this.setState({
      registerClicked: true
    });
  };
  handleChange = () => {
    this.setState({
        checkboxChecked: (!this.state.checkboxChecked),
    });
    this.setState({
        isPublic: (this.state.checkboxChecked),
    });
  }

  renderCreateForm() {
    return (
      <Form className="mb-2">
        <Form.Group as={Row}>
          <Col md={8}>
            <Form.Control
              type="text"
              placeholder="Sharelist name"
              onChange={event => {
                this.setState({
                  name: event.target.value
                });
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-1">
          <Col md={8}>
            <Form.Control
              as="textarea" rows="3"
              maxLength="280"
              placeholder="Caption (280 characters limit)"
              onChange={event => {
                this.setState({
                  caption: event.target.value
                });
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  this.onRegisterClicked();
                }
              }}
            />
          </Col>
        </Form.Group>
        <Form.Group className="mb-1">
            <Form.Check 
                type="checkbox" 
                label="Make Sharelist private"
                defaultChecked={this.state.checkboxChecked}
                onChange={this.handleChange}
            />
        </Form.Group>
        
        <Button className="w-100"variant="primary" onClick={this.onRegisterClicked}>
          Add Sharelist
        </Button>
      </Form>
    );
  }

  render() {
    return (
      <Container className="child-container">
                <Navbar expand="lg" bg="light" variant="light" sticky="top" fixed="top" className="top-nav nav-fill">
                    <Nav>
                    <Nav.Link>
                        <Button onClick={() => this.props.history.goBack()}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </Button>
                    </Nav.Link>
                    </Nav>
                    <Navbar.Brand className="brand">{"Add Sharelist"}</Navbar.Brand>
                </Navbar>
        <Row className="pt-3">
          <Col md={8}>
            <Card>
                <Card.Body>
                {this.state.successfulAdd
                  ? this.redirectToProfile()
                  : this.renderCreateForm()}
                </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(CreateSharelistPage);

CreateSharelistPage.propTypes = {
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired
};
